// import ReferInputPc from './ReferInputPc'
// import { observer } from 'mobx-react'
// import hocWithBaseElementWrap from '../../utils/hocWithBaseElementWrap';
// export default hocWithBaseElementWrap(observer(ReferInputPc))

import ReferInput from '../ReferInputPcNew'
export default ReferInput
